import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getMe, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(false);

  const refreshUsage = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      return null;
    }
    try {
      const me = await getMe();
      setUser(me);
      return me;
    } catch {
      clearToken();
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refreshUsage();
      setLoading(false);
    })();
  }, [refreshUsage]);

  const login = (userObj, token) => {
    setToken(token);
    setUser(userObj);
    setShowLogin(false);
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, logout, refreshUsage, showLogin, setShowLogin, showUpgrade, setShowUpgrade }}
    >
      {children}
    </AuthContext.Provider>
  );
};
